import { Vue, BitrixVue } from 'ui.vue';
import { userStore } from 'germes.multibasket';
import './style.css';
import './sku_whait_toggle_button'
import './sku_analog_toggle_button';
// import './sku_bonus_toggle_button';
Vue.component('vue-product-quantity-settings-bar', {
    data() {
        return {
            possibility: 0
        };
    },
    props: {
        productId: {
            type: Number,
            required: true
        },
        productAnalog: {
            type: String
        },
        showNotes: {
            type: Boolean,
            default: false
        },
        showClear: {
            type: Boolean,
            default: true
        },
        showAtantion: {
            type: Boolean,
            default: false
        },
        showCanbuy: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        localize() {
            return Vue.getFilteredPhrases("");
        },
        isAnalog(state) {
            return state.$props.productAnalog == 'Y';
        },
        hasModuleBasket(state) {
            return state.$store.hasModule("basket");
        },
        hasModuleCatalog(state) {
            return state.$store.hasModule("catalog");
        },
        cartProduct(state) {
            return state.hasModuleBasket ? state.$store.getters['basket/findItem'](state.$props.productId) : {};
        },
        cartProductPossibility(state) {
            return parseFloat(state.cartProduct?.CAN_BUY_IN_PERCENT);
        },
        catalogProduct(state) {
            return state.hasModuleCatalog ? state.$store.getters['catalog/findItem'](state.$props.productId) : {};
        },
        catalogProductPossibility(state) {
            return parseFloat(state.catalogProduct?.CAN_BUY_IN_PERCENT);
        },
        basketStatus(state) {
            return state.hasModuleBasket ? state.$store.getters['basket/basketStatus'] : null;
        },
        catalogProductQuantity(state) {
            return state.catalogProduct ? state.catalogProduct.QUANTITY : 0;
        },
        productProgressPosibility(state) {
            if (state.$props.progressPosibility
                && state.possibility != state.$props.progressPosibility
            ) {
                state.possibility = state.$props.progressPosibility;
            } else if (parseInt(state.catalogProduct?.QUANTITY) != parseInt(state.cartProduct?.QUANTITY)
                && state.catalogProductPossibility >= 0
                && state.possibility != state.catalogProductPossibility
            ) {
                state.possibility = state.catalogProductPossibility;
            } else if (state.cartProductPossibility >= 0
                && state.possibility != state.cartProductPossibility
            ) {
                state.possibility = state.cartProductPossibility;
            }
            return state.possibility;
        },
        catalogProductCanBuy(state) {
            return (state.catalogProductQuantity > 0 && state.productProgressPosibility == 100);
        },
        buttonComponentList(state) {
            return state.hasModuleCatalog ? state?.$store.getters['catalog/getProductSettingsModule'] : {};
        },
        alertTitle: (state) => {
            return state.localize.ATANTION?.replace('#NODE#', state.catalogProduct?.ATANTION)
        },
        settingsTitle: (state) => {
            return state.localize.PRODUCT_SETTINGS_BAR_NAME?.replace('#NAME#', state.catalogProduct?.NAME)
        },
        notesTitle: (state) => {
            return state.cartProduct?.NOTES
        }
    },
    methods: {
        quantityClear: function (event) {
            if (!!this.isAnalog) {
                this.catalogProduct.SEND2BASKET = false;
            } else {
                this.catalogProduct.SEND2BASKET = true;
            }
            this.$store.dispatch('catalog/changeQuantity', { item: this.catalogProduct, quantity: 0 }).then((result) => {
                //
            });
            this.catalogProduct.CAN_BUY_IN_PERCENT = null; // TODO убрать
        },
    },
    template: `<div v-cloak
            v-if="catalogProduct"
            :id="'SETTINGS_DIV_'+productId"
            :title="settingsTitle"
            :style="{background: (basketStatus=='loading'?'var(--ui-btn-wait-loader)':'')}"
            class="vue-product-quantity-settings-bar-init"
            >
            <template v-for="buttonComponent in buttonComponentList">
                <component :data-sort="buttonComponent.sort" :is="buttonComponent.name" :product-id="productId" :product-analog="productAnalog"></component>
            </template>
            <div
                v-if="showAtantion && alertTitle"
                :id="'ALERT_'+productId"
                :title="alertTitle"
                data-toggle="tooltip"
                data-placement="bottom"
                class="text-info"
                ><i class="fas fa-exclamation-triangle"></i></div>
            <div
                v-if="showCanbuy && catalogProductCanBuy"
                :id="'DONE_'+productId"
                :title="localize.DONE"
                data-toggle="tooltip"
                data-placement="bottom"
                class="text-success"
                ><i class="fas fa-check-circle"></i></div>
            <div
                v-if="showNotes && notesTitle"
                :id="'INFO_'+productId"
                :title="notesTitle"
                data-toggle="tooltip"
                data-placement="bottom"
                class="text-info"
                ><i class="ui-btn-clock"></i></div>
            <div
                v-if="showClear && catalogProductQuantity"
                :id="'CLEAR_'+productId"
                @click.stop="quantityClear"
                :title="localize.VUE_CLEAR_INPUT"
                class="ml-auto text-danger pointer"
                style="font-size: 1.2em;"
                >
                <i class="fas fa-close"></i>
            </div>
        </div>`
});
